const Video = ({
  width = 35,
  height = 36,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 35 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.71289 7.36705C5.71289 6.65359 6.29226 6.07422 7.00572 6.07422H27.8551C28.5686 6.07422 29.1479 6.65359 29.1479 7.36705V28.2164C29.1476 28.5592 29.0113 28.8878 28.7689 29.1302C28.5265 29.3726 28.1979 29.5089 27.8551 29.5093H7.00572C6.66295 29.5089 6.33431 29.3726 6.09193 29.1302C5.84955 28.8878 5.71324 28.5592 5.71289 28.2164V7.36705ZM8.31679 8.67811V26.9054H26.544V8.67811H8.31679ZM15.6363 13.1243L21.9885 17.3582C22.06 17.4057 22.1185 17.4702 22.1591 17.5458C22.1996 17.6215 22.2208 17.7059 22.2208 17.7917C22.2208 17.8776 22.1996 17.962 22.1591 18.0377C22.1185 18.1133 22.06 18.1778 21.9885 18.2253L15.635 22.4592C15.5567 22.5112 15.4658 22.5409 15.3719 22.5454C15.278 22.5498 15.1847 22.5287 15.1018 22.4844C15.0189 22.4401 14.9495 22.3742 14.9011 22.2937C14.8526 22.2131 14.8269 22.121 14.8265 22.027V13.5565C14.8267 13.4623 14.8524 13.3699 14.9009 13.2892C14.9495 13.2085 15.019 13.1424 15.1021 13.098C15.1852 13.0537 15.2787 13.0327 15.3728 13.0373C15.4669 13.0419 15.558 13.072 15.6363 13.1243V13.1243Z"
        fill="#133345"
      />
    </svg>
  );
};

export default Video;
